import React, { useEffect } from 'react'
import { Chat, withObservables } from '@repo/db'
import { dbInstance } from '@repo/db/src/instances/web'
import { FormProvider } from 'react-hook-form'
import { ConfirmCancel } from '@web/modules/core'
import { ComponentFlowMessageVO } from '@repo/types'
import { useSendOrderMessageFormWeb } from '@web/modules/send-order-message/hooks/useSendOrderMessageFormWeb'
import { SendOrderMessageFormInfo } from '@web/modules/send-order-message/components/index'

interface SendOrderMessageFormProps {
  chat: Chat
  isSubmitting: boolean
  onConfirm: (vo: ComponentFlowMessageVO) => void
  onCancel: () => void
}

const SendOrderFormMessage = ({ chat, isSubmitting, onConfirm, onCancel }: SendOrderMessageFormProps) => {
  const { form } = useSendOrderMessageFormWeb(chat)
  useEffect(() => {}, [form])
  return (
    <FormProvider {...form}>
      <SendOrderMessageFormInfo />
      <div className='my-mili mx-deca'>
        <ConfirmCancel
          confirmLabel='Enviar Mensagem'
          confirmDisabled={!form.formState.isValid}
          isSubmitting={isSubmitting}
          onConfirm={form.handleSubmit(onConfirm)}
          onCancel={onCancel}
        />
      </div>
    </FormProvider>
  )
}

const enhance = withObservables(['chatId'], ({ chatId }) => ({
  chat: dbInstance.chatRepository.observeChatByChatId(chatId)
}))

export default enhance(SendOrderFormMessage)
